import React from 'react'
import { FormattedMessage } from 'react-intl'
import EmployeeCard, { IEmployee } from 'components/EmployeeCard'
import CheckboxGroup from 'components/CheckboxGroup'

import messages from './messages'
import styles from './EmployeesSection.scss'

type EnrichedEmployeesLocationType = {
  originalLocation: string
  count: number
  coordinates?: string
}

export type IEmployeesSection = {
  employees: Array<IEmployee>
  enrichedEmployeeLocations: Array<EnrichedEmployeesLocationType>
}

export default function EmployeesSection({ employees, enrichedEmployeeLocations }: IEmployeesSection) {
  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h3 className={styles.summary}>
          <div className={styles.title}>
            <FormattedMessage {...messages.employees} />
          </div>
        </h3>
      </header>
      <div className={styles.content}>
        <div className={styles.filters}>
          <CheckboxGroup
            type='regular'
            name='employeeFilters'
            options={enrichedEmployeeLocations.map(({ originalLocation, count }) => `${originalLocation} (${count})`)}
            selections={[]}
            onChange={() => {}}
          />
        </div>
        <div>
          <div className={styles.title}>
            <FormattedMessage
              {...messages.identified}
              values={{ count: employees ? employees.length : 0 }}
              tagName='span'
            />
          </div>
          <div className={styles.employees}>
            {!!employees &&
              employees.map(employee => (
                <div className={styles.employee} key={employee.name}>
                  <EmployeeCard
                    name={employee.name}
                    title={employee.title}
                    location={employee.location}
                    photoUrl={employee.photoUrl}
                    profileUrl={employee.profileUrl}
                  />
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  )
}
